import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

import { reactive, ref, nextTick } from "vue";
import { Axios } from "../../assets/js/ls_com_axios.js";
import {
  TabsPaneContext,
  FormInstance,
  FormRules,
  ElMessage,
  ElTable,
} from "element-plus";
import { resolve } from "dns";

// 表单
// interface RuleForm {
//   address: string;
//   districtId: number;
//   industryId: number;
//   nickName: string;
//   provinceId: number;
//   remark: string;
//   sex: string;
// }
const percentageValue = 30;

export default /*@__PURE__*/_defineComponent({
  __name: 'basicsPage',
  setup(__props) {

const formSize = ref("default");
// const ruleFormRef = ref<FormInstance>();
const ruleFormRef = ref();
const progressValue = (percentage) =>
  percentage === 100 ? "100%" : `${percentage}%`;
// do not use same name with ref
const userList = JSON.parse(localStorage.getItem("userList"));
const reset = () => {
  ruleFormRef.value.resetFields();
}
const ruleForm = ref({
  address: "", // 具体地址
  districtId: 0,
  industryId: '', // 行业ID
  nickName: "", // 昵称
  provinceId: [] as any, // 所在地区省
  remark: "", // 个人简介
  sex: "", // 性别
});

/**
 * 行业类型请求
 */
const hangyelist = ref([]);
const hangyetypoe = function () {
  let params = {
    memberType: "CREATOR",
  };
  Axios("GET", "/member/type/listby", params, false, function (res: any) {
    hangyelist.value = res.data.data;
  });
};
hangyetypoe();
/**
 * 所在地区
 */
const props = {
  lazy: true,
  lazyLoad(node: any, resolve: any) {
    const { level, id } = node;
    if (level == 0) {
      areaaxios(resolve, 1, 0);
    } else if (level == 1) {
      areaaxios(resolve, node.data.value, 1);
    }
  },
};

// 请求行业类型

const onSubmit = async () => {
  ruleFormRef.value.validate(async (isValid: boolean, fields?: any) => {
    if (isValid) {
      let obj = { ...ruleForm.value };

      let pro = ruleForm.value.provinceId[0];
      let dis = ruleForm.value.provinceId[1];
      obj.provinceId = pro;
      obj.districtId = dis;
      obj.realPAddress = "";
      obj.realDAddress = "";

      addresList.value.forEach((e) => {
        if (e.value == obj.provinceId) {
          obj.realPAddress = e.label;
        }
      });
      let arr = await areaaxios1(obj.provinceId);

      arr.forEach((e) => {
        if (e.value == obj.districtId) {
          obj.realDAddress = e.label;
        }
      });

      onSubmitAxios(obj).then(() => {
        ElMessage.success("操作成功");
      });
    }
  });
};
//保存接口
const onSubmitAxios = (obj: any) => {
  //resolve, reject    resolve 成功  reject 失败
  return new Promise((resolve, reject) => {
    Axios("POST", "/member/update-self", obj, false, function (res: any) {
      if (res.data.code == 200) {
        resolve(res.data);
      } else {
        reject();
      }
    });
  });
};

const areaaxios1 = (pid: any) => {
  return new Promise((resolve, reject) => {
    let params = {
      pid: pid,
    };
    Axios(
      "GET",
      "/system/district/list-all",
      params,
      false,
      function (res: any) {
        const list: { label: any; value: any; leaf: any }[] = [];
        res.data.data.forEach((element: any) => {
          list.push({
            label: element.districtName,
            value: element.id,
          });
        });
        resolve(list);
      }
    );
  });
};
//请求封装

/**
 * 所在地区
 * @param resolve
 * @param pid
 * @param level
 */
const addresList = ref([] as any);
const areaaxios = (resolve: any, pid: any, level: any) => {
  let params = {
    pid: pid,
  };
  Axios("GET", "/system/district/list-all", params, false, function (res: any) {
    const list: { label: any; value: any; leaf: any }[] = [];
    res.data.data.forEach((element: any) => {
      list.push({
        label: element.districtName,
        value: element.id,
        leaf: level >= 1,
      });
    });
    list.length == 34 ? (addresList.value = list) : "";
    // ruleForm.value.provinceName =list
    resolve(list);
  });
};

/**
 * 请求个人信息
 */
const userlog = () => {
  return new Promise((resolve, reject) => {
    Axios("GET", "/member/login-info", null, false, function (res: any) {
      resolve(res.data.data);
    });
  });
};

// 获取个人信息
userlog()
  .then((res: any) => {
    ruleForm.value.address = res.address; // 具体地址
    ruleForm.value.districtId = res.districtId;
    ruleForm.value.industryId = (res as any)?.industryId; // 行业ID
    ruleForm.value.nickName = (res as any)?.nickName; // 昵称
    ruleForm.value.provinceId = [res.provinceId, res.districtId]; // 所在地区省
    ruleForm.value.remark = res.remark; // 个人简介
    ruleForm.value.sex = res.sex; // 性别
    console.log(ruleForm.value);
  })
  .catch((error) => {
    console.log(error);
  });
//处理级联选择器
nextTick(() => {
  // this.$refs.myForm.validate
  // var node=this.$ref.areas.getCheckedNodes(); //获取当前选中节点
  // if(node&&node[0]&&node[0].pathNodes){//选中节点的所有父节点
  //   for(var i=0;i<node[0].pathNodes.length;i++){
  //     node[0].pathNodes[i].loaded=true; //节点的加载状态设为true，就不会再加载了
  //   }
  // }
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_form, {
      style: {"width":"6.4rem"},
      ref_key: "ruleFormRef",
      ref: ruleFormRef,
      model: ruleForm.value,
      "label-width": "100px",
      class: "demo-ruleForm",
      "label-position": "left"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "昵称",
          prop: "nickName",
          rules: [{ required: true, message: '不能为空！', trigger: 'change' }]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: ruleForm.value.nickName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ruleForm.value.nickName) = $event)),
              placeholder: "请输入昵称"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "性别",
          rules: [{ required: true, message: '不能为空！', trigger: 'change' }]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: ruleForm.value.sex,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ruleForm.value.sex) = $event)),
              placeholder: "Select",
              size: "mini",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_component_el_option, {
                  key: '0',
                  label: "男",
                  value: '0'
                })),
                (_openBlock(), _createBlock(_component_el_option, {
                  key: '1',
                  label: "女",
                  value: '1'
                }))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "职业行业",
          prop: "industryId",
          placeholder: "Select",
          rules: [{ required: true, message: '不能为空！', trigger: 'change' }]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: ruleForm.value.industryId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((ruleForm.value.industryId) = $event)),
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hangyelist.value, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.id,
                    label: item.memberClass,
                    value: item.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "所在地区",
          prop: "provinceId",
          rules: [{ required: true, message: '不能为空！', trigger: 'change' }]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_cascader, {
              ref: "areas",
              props: props,
              modelValue: ruleForm.value.provinceId,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((ruleForm.value.provinceId) = $event)),
              placeholder: "请选择",
              "show-all-levels": false
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "具体地址",
          prop: "address"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: ruleForm.value.address,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((ruleForm.value.address) = $event)),
              placeholder: "请输入"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "个人简介",
          prop: "remark"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              type: "textarea",
              modelValue: ruleForm.value.remark,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((ruleForm.value.remark) = $event)),
              placeholder: "请输入您的个人简介，最多不超过200字。（为了维护健康的社区环境，请勿填写手机号、微信等信息）"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createElementVNode("div", { style: {"display":"flex"} }, [
      _createElementVNode("div", {
        class: "dataBtn",
        onClick: onSubmit
      }, "保存"),
      _createElementVNode("div", {
        class: "dataCzBtn",
        onClick: reset
      }, "重置")
    ])
  ]))
}
}

})